module.exports = __webpack_public_path__ + "assets/images/payspace-not-active@2x.9d009c2e394e8f97c0408170a337c4bf.webp";